<script>

    import { toast } from 'bulma-toast'
    import { userStore, usersStore, modalStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Switch from '../$components/switch.svelte'
    import Form from '../$components/form.svelte'
    import Select from '../$components/select.svelte'
    import Button from '../$components/button.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputPassword from '../$components/input.password.svelte'
    import InputPricingTag from '../$components/input.pricing.tag.svelte'

    let data = {
        role: $userStore.role,
        corporate: $userStore.corporate,
        firstName: $userStore.firstName,
        lastName: $userStore.lastName,
        phone: $userStore.phone,
        status: $userStore.status,
        permissions: $userStore.permissions || [],
        autoInvoice: $userStore.autoInvoice,
        statusQuotation: $userStore.statusQuotation,
        statusShipment: $userStore.statusShipment,
        pricingTag: $userStore.pricingTag || '',
    }

    let loading = false

    let changeEmail = false
    let changePassword = false

    async function updateUser() {

        if(!changeEmail)
            delete data.email

        if(!changePassword)
            delete data.password
        
        loading = true
        const resp = await UsersService.updateUser($userStore._id, data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        userStore.set(resp.data)
        usersStore.replace(resp.data)
        toast({message: 'Usuario actualizado', type: 'is-success'})

        modalStore.close()

        delete data.email
        delete data.password
    }

</script>

<Form on:submit={updateUser} { loading } >
    <div class="columns">
        <div class="column">
            <Select bind:value={data.status}
                label="Estatus"
                options={[
                    {value: 'enabled', text: 'Activar'},
                    {value: 'disabled', text: 'Bloquear'}
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Select bind:value={data.statusQuotation}
                label="El usuario puede generar cotizaciones"
                options={[
                    {value: 'enabled', text: 'Activar'},
                    {value: 'disabled', text: 'Bloquear'}
                ]}
            />
        </div>
        <div class="column">
            <Select bind:value={data.statusShipment}
                label="El usuario puede generar envíos"
                options={[
                    {value: 'enabled', text: 'Activar'},
                    {value: 'disabled', text: 'Bloquear'}
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputPricingTag bind:value={data.pricingTag} warn />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Select bind:value={data.role}
                label="Rol"
                options={[
                    {value: 'user', text: 'User'},
                    {value: 'admin', text: 'Administrador'},
                    {value: 'support', text: 'Soporte'},
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.firstName} label="Nombre" placeholder="Nombre" />
        </div>
        <div class="column">
            <InputText bind:value={data.corporate} label="Empresa" placeholder="Empresa" required={false} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.phone} label="Teléfono" placeholder="Teléfono" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Switch bind:checked={changePassword} label="Cambiar contraseña" />
        </div>
        {#if changePassword}
            <div class="column">
                <InputPassword bind:value={data.password} label="Contraseña" placeholder="Contraseña" required={false} />
            </div>
        {/if}
    </div>
    <div class="columns">
        <div class="column">
            <Switch bind:checked={changeEmail} label="Cambiar correo" />
        </div>
        {#if changeEmail}
            <div class="column">
                <InputText bind:value={data.email} label="Correo" placeholder="Correo" />
            </div>
        {/if}
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>